import { IDMAINTARH, CHANGE_IDMAINTARH } from 'src/State-Management/Actions/ActionTypes'

const TarhReducer = function (state = 0, action) {
    switch (action.type) {
        case IDMAINTARH:
            return state;
        case CHANGE_IDMAINTARH:
            sessionStorage.setItem('IdMainTarh', action.payload)
            return action.payload;
        default:
            return state;
    }
}

export default TarhReducer